export default __webpack_public_path__ + "static/media/infoGrayDark.314db9e3.svg";